<template>
  <v-container :class="$platform.isMobile() ? 'px-10' : ''" fill-height grid-list-md text-xs-center>
    <v-row justify="center" style="margin: 0px">
      <v-col cols="12" sm="8" md="6" lg="5" justify="space-between">
        <v-row style="padding: 100px 0px 10px 0px">
          <v-col cols="12" class="pa-0">
            <div class="title-login">Acesso Devedora</div>
            <div class="mt-2 mb-10">
              <span class="darkGray--text">Informe seu e-mail e senha para acessar</span>
            </div>
          </v-col>
        </v-row>
        <v-row justify="center" style="height: 300px">
          <v-form ref="form" v-model="loginForm.validForm" lazy-validation style="width: 100%" @submit.prevent="login">
            <v-text-field placeholder="Digite seu e-mail" label="E-mail" ref="username" outlined
              :rules="[$rules.required, $rules.email]" v-model="loginForm.user.username"></v-text-field>

            <v-text-field outlined label="Senha" :append-icon="loginForm.showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              required :rules="[$rules.required]" :type="loginForm.showPassword ? 'text' : 'password'"
              v-model="loginForm.user.password" @click:append="loginForm.showPassword = !loginForm.showPassword"
              hide-details="auto" class="mb-4" id="password"></v-text-field>

            <div class="mt-2">
              <v-btn v-if="$platform.isMobile()" width="100%" color="primary" elevation="0" x-large
                style="height: 56px;" :loading="loginForm.loading" type="submit">Acessar</v-btn>
              <v-btn v-else color="primary" elevation="0" :loading="loginForm.loading"
                type="submit">Entrar</v-btn>
            </div>
            <div class="mt-3">
              <v-btn text small color="primary" class="px-0" @click="showForgotPassword = true">
                Esqueci minha senha
              </v-btn>
            </div>
          </v-form>
        </v-row>
        <v-row align="center" justify="center" class="mt-10">
          <v-col align="left" justify="center">
            <img src="@/assets/logo-bej.svg" :height="60" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <forgot-password v-model="showForgotPassword" />
  </v-container>
</template>

<script>
import axios from 'axios';
import router from '../router';
import * as jwt from "jwt-decode";
import ForgotPassword from './ForgotPassword.vue';

export default {
  name: "Login",

  components: {
    ForgotPassword,
  },

  data: () => ({
    showForgotPassword: false,
    loginForm: {
      validForm: true,
      showPassword: false,
      loading: false,
      user: {},
    },
  }),

  mounted() {
    if (this.$route.query.username) {
      this.loginForm.user.username = this.$route.query.username;
    }
  },

  methods: {
    async login() {
      if (!this.$refs.form.validate()) return;

      let data = {
        email: this.loginForm.user.username,
        password: this.loginForm.user.password,
        type: 2,
      };

      this.loginForm.loading = true;

      try {
        const result = await axios.post('/api/admin/client/login', data);

        if (!result.data.status) throw new Error();

        localStorage.setItem('token', JSON.stringify(result.data.content));

        var dataUser = jwt(result.data.content.token);

        this.$root.user = dataUser.data;
        localStorage.setItem('user', JSON.stringify(dataUser));
        this.setSelectedClient(dataUser.data);

        router.push("/home");

      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
        this.loginForm.user.password = "";
      } finally {
        this.loginForm.loading = false;
      }
    },

    setSelectedClient(user) {
      const clients = user && user.clients ? user.clients : [];
      const clientIds = user && user.client_ids && user.client_ids.length
        ? user.client_ids
        : clients.map((client) => client.id);
      const currentClientId = Number(localStorage.getItem('selectedClientId'));
      const selectedClientId = clientIds.map(Number).includes(currentClientId)
        ? currentClientId
        : Number(clientIds[0] || user.client_id);

      if (selectedClientId) {
        localStorage.setItem('selectedClientId', String(selectedClientId));
      }
    },
  },
};
</script>

<style scoped lang="scss">
.title-login {
  color: #1E1E2D;
  font-family: 'Avenir LT Std';
  font-size: 28px;
  font-weight: 700;
  line-height: 1.3;
}
</style>
